// src/stateManagers/roleAccess/access.ts
//
// ONE place that says which permission each page needs.
//
//   'module'          -> user needs that module's "view" permission
//   'module:action'   -> user needs that exact action (add, edit, delete, approve, ...)
//   'public'          -> everyone who is logged in
//   'admin'           -> admin / superadmin only
//
// The LONGEST matching path wins, and sub-pages inherit their parent's rule.
// e.g. '/fees/history' has no line below, so it uses '/fees'.
// Any path that is not listed here is admin-only (fails safe).
//
// Adding a page:
//   1. Backend: add the module to GetRoleAccessModules (if it is new).
//   2. Here: add ONE line.
// The sidebar and the route guard both read this file.

export const ROUTE_ACCESS: Record<string, string> = {
  '/': 'public', // dashboard

  // ── Students ──
  '/students': 'students',
  '/students/bulk-photos': 'bulk_profile_photos',
  '/hall-tickets': 'students',
  '/students-pdf': 'students',

  // ── People ──
  '/teachers': 'teachers',
  '/staff': 'staff',
  '/staff/staff-attendance': 'staff_attendance',

  // ── Timetable ──
  '/timetable': 'timetable',
  '/timetable/assigned-teachers': 'assigned_teachers',

  // ── School life ──
  '/noticeboard': 'noticeboard',
  '/events': 'events',
  '/exams': 'exams_calendar',
  '/student-issues': 'issues',
  '/visitors': 'visitors',

  // ── Gate ──
  // If gate guards should scan entries but not manage passes,
  // create a separate backend module and change '/gate-entry'.
  '/gate-passes': 'gate_passes',
  '/gate-entry': 'gate_passes',

  // ── Money ──
  '/fees': 'fees_management',
  '/expenses': 'expenses',
  '/payroll-management': 'payroll_management',

  // ── Credentials / settings ──
  // '/credentials': 'credentials',
  // '/bulk-password-reset': 'reset_users_password',
  // '/settings': 'settings',

  // ── Letters (view to see the list, add/edit for the forms) ──
  '/letterheads': 'letterheads',
  '/letterheads/new': 'letterheads:add',
  '/letterheads/edit': 'letterheads:edit',
  '/letterhead-templates': 'letterhead_templates',
  '/letterhead-templates/new': 'letterhead_templates:add',
  '/letterhead-templates/edit': 'letterhead_templates:edit',

  // ── Dev only (not a backend module) ──
  '/subjects': 'admin',
};

export const ruleOf = (path: string): string => {
  const clean = path.split('?')[0].replace(/\/+$/, '') || '/';

  let best = '';
  for (const p of Object.keys(ROUTE_ACCESS)) {
    if ((clean === p || clean.startsWith(p + '/')) && p.length > best.length) {
      best = p;
    }
  }
  return best ? ROUTE_ACCESS[best] : 'admin';
};